<template>
  <div class="user-teams">
    <div class="user-teams__heading">
      <h1 class="user-teams__title page-title">Teams</h1>
      <router-link :to="{ name: 'TeamForm' }">
        <el-button type="primary">Create a team</el-button>
      </router-link>
    </div>

    <div class="user-teams__list card">
      <div
        class="user-teams__item"
        v-for="(team, index) in teamArray"
        :key="team.teamId"
      >
        <div class="team-preview">
          <router-link
            :to="{ name: 'TeamPage', params: { link: team.link } }"
            class="team-preview__link"
          >
            <el-avatar class="team-preview__avatar" :size="50">
              <activity-image :activity="team.activityId" :alt="team.name" />
            </el-avatar>

            <div class="team-preview__info">
              <div class="team-preview__name">
                {{ team.name }}
                <el-tag v-if="team.userRole" class="team-preview__role">{{ team.userRole }}</el-tag>
              </div>

              <div class="team-preview__description">
                {{ team.activityName }}
              </div>

              <div v-if="team.teammateCount" class="team-preview__participants">
                <i class="team-preview__participants-icon el-icon-user" />
                {{ team.teammateCount }}
                {{ team.teammateCount === 1 ? 'member' : 'members' }}
              </div>
            </div>
          </router-link>

          <el-button type="danger" plain @click="handleLeaveTeam(team)">
            Leave
          </el-button>
        </div>

        <el-divider v-if="index < teamArray.length - 1" />
      </div>

      <div class="user-teams__empty-text" v-if="teamArray.length === 0">
        You are not a member of any team. Create your own team and invite your
        friends
      </div>
    </div>

    <el-dialog
      v-model="isTeamEventConfirmationVisible"
      width="30%"
      title="Confirmation"
    >
      <span v-if="teamToLeave">
        Are you sure you want to leave team «{{ teamToLeave.name }}»?
      </span>
      <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleCloseLeaveConfirmation">
          Cancel
        </el-button>
        <el-button
          type="danger"
          @click="requestLeaveTeam"
          :disabled="isButtonDisabled('cancel-participation')"
        >
          Leave
        </el-button>
      </span>
    </template>
    </el-dialog>
  </div>
</template>

<script>
import ActivityImage from '@/components/common/ActivityImage.vue';
import { getCurrentUserTeams, leaveTeam } from '@/api/team.js';
import { disableButton } from '@/mixins/disableButton.js';
import { showMessage } from '@/utils/messages.js';

export default {
  name: 'UserTeams',
  mixins: [disableButton],
  components: {
    ActivityImage,
  },
  data() {
    return {
      teamArray: [],
      teamToLeave: null,
      isTeamEventConfirmationVisible: false,
    };
  },
  methods: {
    showMessage,
    async fetchUserTeams() {
      const { data, success } = await getCurrentUserTeams();

      if (success) {
        this.teamArray = data.items;
      }
    },
    async requestLeaveTeam() {
      const { teamId } = this.teamToLeave;
      const { success } = await leaveTeam({ teamId });

      if (success) {
        this.showMessage({
          type: 'success',
          message: 'You left the team',
        });
        this.handleCloseLeaveConfirmation();
        this.fetchUserTeams();
      }
    },
    handleLeaveTeam(team) {
      this.teamToLeave = team;
      this.isTeamEventConfirmationVisible = true;
    },
    handleCloseLeaveConfirmation() {
      this.teamToLeave = null;
      this.isTeamEventConfirmationVisible = false;
    },
  },
  created() {
    this.fetchUserTeams();
  },
};
</script>

<style lang="scss">
.user-teams {
  &__heading {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
  }
  &__title {
    margin: 0;
    margin-bottom: var(--global-dimension-size-250);
    font-weight: 500;
    font-size: var(--font-size-800);
  }
  &__list {
  }
  &__item {
  }
  &__empty-text {
  }
}

.team-preview {
  $this: &;

  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  &__link {
    display: flex;
    flex-flow: row nowrap;
    flex-grow: 1;

    &:hover {
      #{$this}__name {
        color: var(--color-primary-400);
      }
    }
  }

  &__avatar {
    margin-right: var(--global-dimension-size-125);
  }
  &__info {
  }
  &__name {
    font-weight: var(--global-font-weight-medium);
  }

  &__role {
    margin-left: var(--global-dimension-size-125);
  }

  &__description {
    margin-bottom: var(--global-dimension-size-65);
    font-size: var(--font-size-200);
  }
  &__participants-icon {
    margin-right: var(--global-dimension-size-65);
  }
  &__participants {
    font-size: var(--font-size-200);
  }
}
</style>
